





























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePpiVap } from "@/store/modules/PpiVapStore";
import { appModule } from "@/store/modules/app";
import PpiVapSvc from "@/services/PpiVapService";
import BundleItemTriState from "@/components/pemeriksaan/bundle-ppi/BundleItemTriState.vue";
import BundleObservasiList from "@/components/pemeriksaan/bundle-ppi/BundleObservasiList.vue";
import {
  labelObservasi,
  nowHm,
  todayIso,
  trimJam,
  trimTanggal
} from "@/utils/bundlePpiObservasi";
@Component({
  components: { BundleItemTriState, BundleObservasiList }
})
export default class PpiVapPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;

  get readOnly(): boolean {
    return false;
  }

  form: any = this.defaultForm();
  saving = false;
  deleteDialog = false;
  deleting = false;
  loaded = false;
  rowToDelete: any = null;
  showForm = false;

  /** null = item belum/tidak dinilai (tidak masuk denominator kepatuhan). */
  defaultForm() {
    return {
      tanggal_observasi: todayIso(),
      jam_observasi: nowHm(),
      ins_hand_hygiene: null,
      ins_teknik_aseptik: null,
      ins_apd: null,
      ins_sedasi: null,
      mnt_hand_hygiene_ett: null,
      mnt_posisi_kepala_30_45: null,
      mnt_oral_hygiene_6jam: null,
      mnt_manajemen_sekresi: null,
      mnt_kaji_sedasi: null,
      mnt_peptic_ulcer: null,
      mnt_dvt_profilaksis: null,
    };
  }

  get ppiVap() {
    return storePpiVap.currentItem;
  }

  get list() {
    return storePpiVap.list;
  }

  get loading() {
    return storePpiVap.loading;
  }

  get judulForm(): string {
    return this.ppiVap && this.ppiVap.id
      ? "Ubah Observasi — " + labelObservasi(this.ppiVap)
      : "Observasi Baru";
  }

  /** Persen dihitung atas item yang DINILAI saja (kepatuhan_total dari server). */
  get kepatuhanPersen() {
    if (!this.ppiVap) return 0;
    const total = this.ppiVap.kepatuhan_total || 0;
    if (!total) return 0;
    const count = this.ppiVap.kepatuhan_count || 0;
    return Math.round((count / total) * 1000) / 10;
  }

  get kepatuhanColor() {
    const persen = this.kepatuhanPersen;
    if (persen >= 80) return "success";
    if (persen >= 50) return "warning";
    return "error";
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.fetchData();
      this.loaded = true;
    }
  }

  @Watch("ppiVap", { immediate: true })
  onDataChange() {
    if (this.ppiVap) this.populateForm();
    else this.form = this.defaultForm();
  }

  async fetchData() {
    await storePpiVap.getByRegister(this.register);
  }

  /** null dari server = "tidak dinilai" — harus ikut tersalin, jangan di-skip. */
  populateForm() {
    const d = this.ppiVap;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined) {
        this.form[key] = d[key];
      }
    });
    this.form.tanggal_observasi = trimTanggal(d.tanggal_observasi) || todayIso();
    this.form.jam_observasi = trimJam(d.jam_observasi);
  }

  labelObservasi(row: any): string {
    return labelObservasi(row);
  }

  tambahObservasi() {
    storePpiVap.select(null);
    this.showForm = true;
  }

  pilihObservasi(row: any) {
    storePpiVap.select(row);
    this.showForm = true;
  }

  tutupForm() {
    storePpiVap.select(null);
    this.showForm = false;
  }

  cetakObservasi(row: any) {
    PpiVapSvc.printPdf(row.id);
  }

  async save() {
    if (!this.form.tanggal_observasi) {
      appModule.NoticeDelay("Tanggal Observasi harus diisi");
      return;
    }
    this.saving = true;
    try {
      let resp;
      if (this.ppiVap?.id) {
        resp = await PpiVapSvc.update(this.ppiVap.id, {
          ...this.form,
          register_id: this.register,
          pasien_rm: this.rm,
        });
      } else {
        resp = await PpiVapSvc.create({
          ...this.form,
          register_id: this.register,
          pasien_rm: this.rm,
        });
      }
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan Bundle VAP");
        await storePpiVap.getByRegister(this.register);
        if (resp.data.data?.id) {
          await storePpiVap.refresh(resp.data.data.id);
        }
      }
    } catch (e) {
      // handled by service
    }
    this.saving = false;
  }

  confirmDelete(row: any) {
    this.rowToDelete = row || this.ppiVap;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.rowToDelete?.id) {
      this.deleteDialog = false;
      return;
    }
    const terpilih = this.ppiVap && this.ppiVap.id === this.rowToDelete.id;
    this.deleting = true;
    try {
      const resp = await PpiVapSvc.destroy(this.rowToDelete.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menghapus observasi Bundle VAP");
        if (terpilih) this.tutupForm();
        await storePpiVap.getByRegister(this.register);
        this.deleteDialog = false;
        this.rowToDelete = null;
      }
    } catch (e) {
      // handled by service
    }
    this.deleting = false;
  }

  beforeDestroy() {
    storePpiVap.reset();
  }
}
